import React from 'react';

interface IconProps {
    color?: string;  // Cor do ícone
    height?: string; // Altura do ícone
}

const PartnershipIcon: React.FC<IconProps> = ({ color = "#000000", height = "24" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
        height={height}
        width={height}
    >
        <path
            fill={color}
            d="M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9 145.6 118.2c2.9 2.4 5.5 5 7.9 7.7v-193.5l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zm109.3 64.2v223.9c0 17.7 14.3 32 32 32h64v-255.9zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm-592 31.9h64c17.7 0 32-14.3 32-32v-223.8h-96zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6-149.3-121.2-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7l81.8-74.9h-83.8c-8.5 0-16.6 3.4-22.6 9.4l-54.7 54.6v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
        />
    </svg>
);

export default PartnershipIcon;
